/* eslint-disable react/no-multi-comp */
import React from "react"
import { css } from "@jsUtils"
import styles from "@pageStyles/resources.module.scss"
import { FILTERS } from "@data/constants"
import { Analytics } from "@shared"

const TrackedButton = Analytics("button")

const ResourcesFilter = ({ filter, isGridLayout, menu, setMenu }) => {
  const handleClick = config => () => {
    // update hash
    window.location.hash = config.hash

    // if not grid layout, close filter menu
    if (!isGridLayout) {
      setMenu(false)
    }
  }

  return (
    <div className={css(styles.filter, menu && styles.open)}>
      <div className={css(styles.filterBackground, menu && styles.open)} />

      <div className={styles.filterNav}>
        {FILTERS.map((current, index) => (
          <TrackedButton
            adata={current.adata}
            ascope={current.ascope}
            className={css(
              styles.filterLink,
              filter === current.value && styles.active,
              menu && styles.open
            )}
            key={current.key}
            onClick={handleClick(current)}
            style={{ "--animation-position": index }}
            type="button"
          >
            {current.buttonText}
          </TrackedButton>
        ))}
      </div>
      {/* eslint-disable */}
      <div
        className={css(styles.filterOverlay, menu && styles.open)}
        onClick={() => setMenu(false)}
      />
    </div>
  )
}

export default ResourcesFilter
